import React, { useState } from "react";
import { TextField, Button } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";

const TagCreateForm = ({ onCreated }) => {

  const [name, setName] = useState("");
  const [color, setColor] = useState("#3498db");

  const handleCreate = async () => {
    if (!name.trim()) {
      toast.warning("Debes escribir un nombre");
      return;
    }

    try {
      const { data } = await api.post("/tags", {
        name: name.trim(),
        color
      });

      setName("");
      onCreated(data);

    } catch (err) {
      console.log(err.response?.data);
      toast.error("Error al crear etiqueta");
    }
  };

  return (
    <>
      <TextField
        label="Nueva etiqueta"
        fullWidth
        value={name}
        onChange={(e) => setName(e.target.value)}
        autoFocus
        style={{ marginBottom: 10 }}
      />

      <input
        type="color"
        value={color}
        onChange={(e) => setColor(e.target.value)}
        style={{ width: "100%", marginBottom: 10 }}
      />

      <Button
        variant="contained"
        color="primary"
        fullWidth
        onClick={handleCreate}
      >
        Crear etiqueta
      </Button>
    </>
  );
};

export default TagCreateForm;